module.exports = __webpack_public_path__ + "static/media/running-toilet.aa244fa8.png";